// extracted by mini-css-extract-plugin
export default {"comment":"Comment_comment__Og9aN","header":"Comment_header__zC4A-","author":"Comment_author__tkk6l","date":"Comment_date__ABxPT","commentText":"Comment_commentText__FYidX"};